// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type FileSvgrepoCom2SvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function FileSvgrepoCom2SvgIcon(props: FileSvgrepoCom2SvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      x={"0"}
      y={"0"}
      viewBox={"0 0 60 60"}
      xmlSpace={"preserve"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",

        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M12.5 24h25a1 1 0 000-2h-25a1 1 0 000 2zm0-8h10a1 1 0 000-2h-10a1 1 0 000 2zm0 16h25a1 1 0 000-2h-25a1 1 0 000 2zm17 6h-17a1 1 0 000 2h17a1 1 0 000-2zm-3 8h-14a1 1 0 000 2h14a1 1 0 000-2z"
        }
      ></path>

      <path
        d={
          "M48.5 34.363V14.586L33.914 0H1.5v60h44c7.168 0 13-5.832 13-13 0-6.134-4.276-11.277-10-12.637zm-14-30.949L45.086 14H34.5V3.414zM38.578 58H3.5V2h29v14h14v18.044a11.818 11.818 0 00-1-.044c-7.168 0-13 5.832-13 13a13.233 13.233 0 00.087 1.455c.043.382.098.76.173 1.131.009.044.021.087.03.131.072.338.159.67.257.998.025.082.048.165.074.246.113.352.239.698.38 1.037.027.064.057.126.084.189.129.296.269.585.419.869.036.068.07.137.107.205.175.317.363.626.564.927.046.069.094.135.141.203.183.264.375.521.576.77.038.047.074.096.113.143.231.278.475.544.728.801.062.063.125.124.189.186.245.239.496.471.759.69.023.02.045.041.069.06a13.226 13.226 0 001.1.807c.077.049.151.103.228.152zm6.922 0c-6.065 0-11-4.935-11-11s4.935-11 11-11c.312 0 .62.021.926.047.291.028.592.066.909.119l.443.074C52.753 37.293 56.5 41.716 56.5 47c0 6.065-4.935 11-11 11z"
        }
      ></path>

      <path
        d={
          "M51.5 46h-5v-5a1 1 0 00-2 0v5h-5a1 1 0 000 2h5v5a1 1 0 002 0v-5h5a1 1 0 000-2z"
        }
      ></path>
    </svg>
  );
}

export default FileSvgrepoCom2SvgIcon;
/* prettier-ignore-end */
